import React from 'react';
import { Button, Input, Table, Tag, Space, Popconfirm } from 'antd';
import { PrinterOutlined, ClearOutlined, SearchOutlined } from '@ant-design/icons';
import type { ColumnsType } from 'antd/es/table';
import useMaterialReport from './hooks/useMaterialReport';
import { F111 } from '../../services/materialReportApi';

const columns: ColumnsType<F111> = [
  { title: '原料代號', dataIndex: 'f111_01', width: 100, fixed: 'left' },
  { title: '原料名稱(中)', dataIndex: 'f111_11', width: 200 },
  { title: '原料名稱(英)', dataIndex: 'f111_12', width: 200 },
  { title: '分類代號', dataIndex: 'f111_13', width: 100 },
  { title: '規格描述', dataIndex: 'f111_21', width: 200 },
  { title: '規格值(主)', dataIndex: 'f111_22', width: 100, align: 'right' },
  { title: '規格值(副)', dataIndex: 'f111_221', width: 100, align: 'right' },
  { title: '規格單位', dataIndex: 'f111_23', width: 80 },
  { title: '重量(主)', dataIndex: 'f111_24', width: 100, align: 'right' },
  { title: '重量(副)', dataIndex: 'f111_241', width: 100, align: 'right' },
  { title: '重量單位', dataIndex: 'f111_25', width: 80 },
  { title: '廠商料號', dataIndex: 'f111_26', width: 120 },
  {
    title: '啟用', dataIndex: 'f111_30', width: 60, align: 'center',
    render: (v: boolean) => v ? <Tag color="green">Y</Tag> : <Tag color="red">N</Tag>,
  },
];

const P1311Form: React.FC = () => {
  const r = useMaterialReport();

  return (
    <div style={{ padding: 16, maxWidth: 1200 }}>
      <h3 style={{ marginBottom: 16 }}>原料清冊</h3>

      {/* Range inputs */}
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 16, flexWrap: 'wrap' }}>
        <span>原料代號：[從]</span>
        <Input
          value={r.startCode}
          onChange={e => r.onStartChange(e.target.value)}
          maxLength={6}
          style={{ width: 140 }}
          placeholder="起始代號"
        />
        <span>[至]</span>
        <Input
          value={r.endCode}
          onChange={e => r.onEndChange(e.target.value)}
          maxLength={6}
          style={{ width: 140 }}
          placeholder="結束代號"
        />
        <Space>
          <Popconfirm title="確認所選範圍，開始查詢?" onConfirm={r.executeQuery} okText="確認" cancelText="取消">
            <Button type="primary" icon={<SearchOutlined />} loading={r.loading}>開始查詢</Button>
          </Popconfirm>
          <Button icon={<ClearOutlined />} onClick={r.clearResults}>清除</Button>
        </Space>
      </div>

      {/* Results */}
      {r.queried && (
        <div style={{ marginBottom: 8, color: '#999' }}>
          共 {r.records.length} 筆資料
        </div>
      )}

      <Table
        dataSource={r.records}
        columns={columns}
        rowKey="f111_01"
        size="small"
        pagination={{ pageSize: 50, showSizeChanger: true, showTotal: (t) => `共 ${t} 筆` }}
        scroll={{ x: 1400, y: 500 }}
        loading={r.loading}
      />
    </div>
  );
};

export default P1311Form;
